import React, {useContext} from "react";
import {useIntl} from "react-intl";
import {NavLink} from "react-router-dom";
import {KeycloakContext} from "../views/contextProviders/KeycloakProvider";
import {Button, GlobalMenu, TileApplications} from "@spg/component_library";
import {Resolution} from "../logic/API";
import "./InternalGlobalMenu.css";
import {AppSettingsContext} from "../views/contextProviders/AppSettingsProvider";

export function InternalGlobalMenu({
  applications,
}: {
  applications: Resolution<TileApplications>;
}) {
  const intl = useIntl();
  const {portalURL} = useContext(AppSettingsContext);
  const {keycloak, initialized} = useContext(KeycloakContext);

  return (
    <div className="internalGlobalMenu">
      <GlobalMenu
        isLoggedIn={initialized}
        firstName={keycloak.idTokenParsed?.given_name}
        lastName={keycloak.idTokenParsed?.family_name}
        email={keycloak.idTokenParsed?.email}
        applications={applications.payload}
        altTextApplications={intl.formatMessage({
          id: "globalMenu.applications.actions.open",
        })}
        emptyMessage={intl.formatMessage({
          id: applications.unresolved
            ? "globalMenu.applications.messages.loading"
            : "globalMenu.applications.messages.empty",
        })}
        ariaLabelUserImage={intl.formatMessage({
          id: "globalMenu.userWidget.actions.open",
        })}
        primaryButton={
          <NavLink to={portalURL + "/account"} tabIndex={-1}>
            <Button
              label={intl.formatMessage({
                id: "globalMenu.userWidget.actions.manageAccount",
              })}
              onClick={() => null}
              configuration={"primary"}
            />
          </NavLink>
        }
        secondaryButton={
          <NavLink
            to={keycloak.createLogoutUrl({
              redirectUri: window.location.origin + "/login",
            })}
            className="globalMenu__login"
            id="landingPageGlobalMenuLogoutLink"
          >
            {intl.formatMessage({
              id: "globalMenu.userWidget.actions.logout",
            })}
          </NavLink>
        }
        toggleNameTooltipMessage={intl.formatMessage({
          id: "globalMenu.userWidget.actions.tooltipToggleName",
        })}
        toggleEmailTooltipMessage={intl.formatMessage({
          id: "globalMenu.userWidget.actions.tooltipToggleMail",
        })}
        portalOrigin={portalURL}
        imprintLabel={intl.formatMessage({
          id: "globalMenu.userWidget.actions.imprint",
        })}
        privacyPolicyLabel={intl.formatMessage({
          id: "globalMenu.userWidget.actions.privacy",
        })}
      />
    </div>
  );
}
